import { reactive } from 'vue';

export type OfflineDialogKind = 'validation' | 'survey' | 'evidence' | 'overwrite';

export interface OfflineDialogRequest {
  kind: OfflineDialogKind;
  title: string;
  message: string;
  confirmLabel: string;
}

type PendingDialog = OfflineDialogRequest & {
  open: boolean;
  resolve?: (accepted: boolean) => void;
};

export const offlineDialog = reactive<PendingDialog>({
  open: false,
  kind: 'validation',
  title: '',
  message: '',
  confirmLabel: '',
});

export function requestOfflineConfirmation(request: OfflineDialogRequest): Promise<boolean> {
  if (offlineDialog.open) offlineDialog.resolve?.(false);
  Object.assign(offlineDialog, request, { open: true });
  return new Promise<boolean>((resolve) => {
    offlineDialog.resolve = resolve;
  });
}

export function resolveOfflineConfirmation(accepted: boolean): void {
  const resolve = offlineDialog.resolve;
  offlineDialog.open = false;
  offlineDialog.resolve = undefined;
  resolve?.(accepted);
}

